// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldTimeOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldTimeOutlined";
import AntdIcon from '../components/AntdIcon';

var FieldTimeOutlined = function FieldTimeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FieldTimeOutlinedSvg
  }));
};

FieldTimeOutlined.displayName = 'FieldTimeOutlined';
export default React.forwardRef(FieldTimeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FieldTimeOutlined.js
// module id = 1083
// module chunks = 0